export const baseURL = 'https://run.mocky.io/v3'
